var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer",attrs:{"id":"footer"}},[_vm._v(" © 2020 seanTheme All Right Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }